import React, { useEffect } from 'react';
import UserStateContext from '../contexts/UserStateContext';
import userStateReducer from '../reducers/userStateReducer';
import UserStateInterface, { IUserStateMeta } from '../types/userState';
import { CommonStorage } from '../utils/storageHandler';
import APIAdapter from '../APIAdapter';
import AppConfigProvider from './AppConfigProvider';
import { getAuthParams } from '../utils/bridgeCaller';
import { IappEnvironment } from '../types';
import UAHelper from '../utils/uaHelper';
import { IGlobalConfig } from './types';

export default function (props: {
  children: React.ReactNode;
  shouldAvoidCache?: boolean;
  tenantName: string;
}) {
  const [userState, dispatch] = React.useReducer(userStateReducer, {});

  useEffect(() => {
    (async function () {
      try {
        const commonUIConfig = (window?.tenantAppConfig?.global ||
          {}) as IGlobalConfig;
        const { sessionValidateConfig } = commonUIConfig;

        // user state is agnostic of DC switch
        const adapter = new APIAdapter({
          shouldAvoidCache: props?.shouldAvoidCache,
          enableHeliosDCSwitch:
            sessionValidateConfig?.enableHeliosDCSwitch || true,
          enableKevlarSessionService:
            sessionValidateConfig?.enableKevlarSessionService || true
        });
        const response = await adapter.fetch('https://rome.api.flipkart.com/2/session/validate');

        const { SESSION } = await response.json();
        const { fkUA } = await getAuthParams();
        const appEnvironment =
          window?.appEnvironment || ({} as IappEnvironment);
        const { ip, terminalId } = appEnvironment?.xInfo || {};
        const userState: IUserStateMeta = { SESSION, fkUA, ip, terminalId };

        if (SESSION?.sn) {
          // updating the fresh SN value to window
          appEnvironment.SN = SESSION?.sn;
          //eslint-disable-next-line
          window.appEnvironment = appEnvironment;
        }

        dispatch({ type: 'UPDATE', payload: { userState } });
        // Update Storage: To make it accessible from non-React components
        const commonStorage = CommonStorage.getInstance();
        commonStorage.setItem('userState', userState);
      } catch (error) {
        dispatch({ type: 'UPDATE', payload: { error: error as Error } });
        console.error('Failed to update user state', error);
      }
    })();
    return () => {
      // Clear common storage
      const commonStorage = CommonStorage.getInstance();
      commonStorage.removeItem('userState');
    };
  }, [dispatch]);
  return (
    <UserStateContext.Provider value={userState}>
      <AppConfigProvider tenantName={props.tenantName}>
        {props.children}
      </AppConfigProvider>
    </UserStateContext.Provider>
  );
}
